import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, SendIcon } from 'lucide-react';
export function ContactUs() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const subject = encodeURIComponent(`Contact from ${formState.name}`);
    const body = encodeURIComponent(`Name: ${formState.name}\nEmail: ${formState.email}\n\n${formState.message}`);
    window.location.href = `mailto:hello@pawchi.app?subject=${subject}&body=${body}`;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  }
  return <div className="min-h-screen bg-cream" data-id="element-166">
      <div className="max-w-2xl mx-auto px-6 pt-32 pb-20" data-id="element-167">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-168">
          <ArrowLeftIcon size={18} data-id="element-169" />
          Back to Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-3" data-id="element-170">
          Contact Us
        </h1>
        <p className="text-warmBrown/60 text-lg mb-10" data-id="element-171">
          Have a question or feedback? We'd love to hear from you.
        </p>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-172">
          <div className="grid sm:grid-cols-2 gap-5" data-id="element-173">
            <div data-id="element-174">
              <label htmlFor="name" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-175">
                Name
              </label>
              <input id="name" type="text" placeholder="Your name" required value={formState.name} onChange={e => setFormState({
              ...formState,
              name: e.target.value
            })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" data-id="element-176" />
            </div>
            <div data-id="element-177">
              <label htmlFor="email" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-178">
                Email
              </label>
              <input id="email" type="email" placeholder="Your email" required value={formState.email} onChange={e => setFormState({
              ...formState,
              email: e.target.value
            })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" data-id="element-179" />
            </div>
          </div>
          <div data-id="element-180">
            <label htmlFor="message" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-181">
              Message
            </label>
            <textarea id="message" placeholder="Your message" required rows={6} value={formState.message} onChange={e => setFormState({
            ...formState,
            message: e.target.value
          })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors resize-none" data-id="element-182" />
          </div>
          <button type="submit" className="px-8 py-4 rounded-full font-bold text-white bg-peach hover:bg-peach/90 transition-colors shadow-soft-lg flex items-center gap-2" data-id="element-183">
            {submitted ? 'Opening email client...' : <>
                Send Message
                <SendIcon size={16} data-id="element-184" />
              </>}
          </button>
        </form>
      </div>
    </div>;
}